import { put, select, takeEvery } from "redux-saga/effects";
import { defineMessages } from "react-intl";
import { ALERT_TYPES, showAlert } from "../alert/alertActions";
import { getTechnicianInfo, makeApiCall, getVenderNumber } from "../helpers";
import technicianServices from "../../services/technicianServices";
import * as manageLabourerActions from "./manageLabourerActions";
import * as technicianActions from "../technician/technicianActions";

const messages = defineMessages({
    createTechSucceeded: {
        id: "alerts.manage-labourer-sagas.create-labourer-succeeded",
        defaultMessage: "Labourer created",
        description: "Create labourer succeeded alert message",
    },
    updateTechSucceeded: {
        id: "alerts.manage-labourer-sagas.update-labourer-succeeded",
        defaultMessage: "Labourer updated",
        description: "Updated labourer succeeded alert message",
    },
    deactivateTechSucceeded: {
        id: "alerts.manage-labourer-sagas.deactivate-labourer-succeeded",
        defaultMessage: "Labourer deactivated",
        description: "Deactivate labourer succeeded alert message",
    },
    reactivateTechSucceeded: {
        id: "alerts.manage-labourer-sagas.reactivate-labourer-succeeded",
        defaultMessage: "Labourer Reactivated",
        description: "Deactivate labourer succeeded alert message",
    },
    saveTechFailed: {
        id: "alerts.manage-labourer-sagas.fetch-failed",
        defaultMessage: "Save labourer failed",
        description: "Save labourer failed alert message",
    },
    saveSucceeded: {
        id: "alerts.manage-labourer-sagas.save-succeeded",
        defaultMessage: "Save billing SKUs succeeded",
        description: "Save billing activities succeeded alert message",
    },
    saveFailed: {
        id: "alerts.manage-labourer-sagas.save-failed",
        defaultMessage: "Save billing SKUs failed: {responseError}",
        description: "Save billing activities failed alert message",
    },
});

export const watchManageLaboureRequests = function* () {
    yield takeEvery(manageLabourerActions.REQUEST_CONTRACTS, fetchContractsAsync);
    yield takeEvery(manageLabourerActions.REQUEST_SKILLS, fetchSkillsAsync);
    yield takeEvery(manageLabourerActions.CREATE_TECHNICIAN, createTechnician);
    yield takeEvery(manageLabourerActions.UPDATE_TECHNICIAN, updateTechnician);
    yield takeEvery(manageLabourerActions.DEACTIVATE_TECHNICIAN, deactivateTechnician);
    yield takeEvery(manageLabourerActions.IS_TECHNICIAN_ENABLED, isTechnicianEnabled);
};

const fetchContractsAsync = function* () {
    try {
        const technicianInfo = yield select(getTechnicianInfo);
        const contractsData = yield makeApiCall(technicianServices.getContracts, technicianInfo.vendorNumber);
        yield put(manageLabourerActions.requestContractsSucceeded(contractsData));
    } catch (responseError) {
        yield put(manageLabourerActions.requestContractsFailed());
    }
};
const fetchSkillsAsync = function* () {
    try {
        // const technicianInfo = yield select(getTechnicianInfo);
        const skills = yield makeApiCall(technicianServices.getSkills);
        yield put(manageLabourerActions.requestSkillsSucceeded(skills));
    } catch (responseError) {
        yield put(manageLabourerActions.requestContractsFailed());
    }
};
const createTechnician = function* (action) {
    try {
        const vendorNumber = yield select(getVenderNumber);
        action.technician["vendorNumber"] = vendorNumber;
        const result = yield makeApiCall(technicianServices.createTechnician, JSON.stringify(action.technician));
        if (result.statusCodeValue !== undefined && (result.statusCodeValue == 226 || result.statusCodeValue < 200 || result.statusCodeValue >= 300))
            yield put(manageLabourerActions.createTechnicianFailed(result));
        else {
            yield put(technicianActions.requestTechnicians());
            yield put(manageLabourerActions.createTechnicianFailed("success"));
            yield put(showAlert(Date.now(), messages.createTechSucceeded, ALERT_TYPES.success));
        }
        if (result.statusCodeValue !== undefined && (result.statusCodeValue < 200 || result.statusCodeValue >= 300)) {
            yield put(manageLabourerActions.createTechnicianFailed(result));
            yield put(showAlert(Date.now(), messages.saveTechFailed, ALERT_TYPES.error));
        }
    } catch (responseError) {
        yield put(showAlert(Date.now(), messages.saveTechFailed, ALERT_TYPES.success, { responseError }));
    }
};
const updateTechnician = function* (action) {
    try {
        const patch = yield makeApiCall(technicianServices.editTechnician, JSON.stringify(action.technician));

        if (patch && patch.statusCode && patch.statusCode === "OK") {
            // refresh the updated task
            yield put(technicianActions.requestTechnicians());
            // Show UI alert to the user so he know that the action succeeded
            yield put(manageLabourerActions.createTechnicianFailed("success"));
            yield put(showAlert(Date.now(), messages.updateTechSucceeded, ALERT_TYPES.success));
        }
        if (patch.statusCodeValue !== undefined && (patch.statusCodeValue < 200 || patch.statusCodeValue >= 300)) {
            yield put(manageLabourerActions.createTechnicianFailed(patch));
            yield put(showAlert(Date.now(), messages.saveTechFailed, ALERT_TYPES.error));
        }
    } catch (responseError) {
        yield put(showAlert(Date.now(), messages.saveTechFailed, ALERT_TYPES.success, { responseError }));
    }
};
const deactivateTechnician = function* (action) {
    try {
        const resp = yield makeApiCall(technicianServices.deactivateTechnician, { id: action.technicianKeyClockId, enabled: !!action.status });
        if (resp && resp.statusCode == "OK") {
            yield put(manageLabourerActions.setSelectedLabourerStatus(!!action.status));
            yield put(
                showAlert(Date.now(), !!action.status ? messages.reactivateTechSucceeded : messages.deactivateTechSucceeded, ALERT_TYPES.success),
            );
        }
        if (resp.statusCodeValue !== undefined && (resp.statusCodeValue == 226 || resp.statusCodeValue < 200 || resp.statusCodeValue >= 300)) {
            yield put(showAlert(Date.now(), messages.saveTechFailed, ALERT_TYPES.error));
        }
    } catch (responseError) {
        yield put(showAlert(Date.now(), messages.saveTechFailed, ALERT_TYPES.success, { responseError }));
    }
};

const isTechnicianEnabled = function* (action) {
    try {
        const resp = yield makeApiCall(technicianServices.isTechnicianEnabled, action.technicianKeyClockId);
        if (resp && resp.statusCode == "OK") {
            yield put(manageLabourerActions.setSelectedLabourerStatus(resp.body == "true"));
        }
    } catch (responseError) {
        yield put(showAlert(Date.now(), messages.saveTechFailed, ALERT_TYPES.success, { responseError }));
    }
};
